// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookingLink_main__9cR36 {
  background-color: var(--color-dark-2);
  max-width: 100vw;
  min-height: 100vh;
  padding: 5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.BookingLink_main__img__07hmy {
  height: 7rem;
}
.BookingLink_main__titles__WQRGs {
  width: 60rem;
}
@media only screen and (max-width: 31.25em) {
  .BookingLink_main__titles__WQRGs {
    width: 42rem;
  }
}
.BookingLink_main__form__qtAqc {
  background-color: var(--color-white);
  padding: 4rem 2rem;
  margin: 1rem 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  width: 50rem;
}
@media only screen and (max-width: 31.25em) {
  .BookingLink_main__form__qtAqc {
    width: 38rem;
  }
}

.BookingLink_beside__\\+43MD {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 2rem;
}
@media only screen and (max-width: 25em) {
  .BookingLink_beside__\\+43MD {
    grid-template-columns: 100%;
  }
}

.BookingLink_mima__qIsQq {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
}
.BookingLink_mima__qIsQq > :not(:last-child) {
  margin-right: 1rem;
}
.BookingLink_mima__logo__Kd3x9 {
  height: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Booking/BookingLink.module.scss"],"names":[],"mappings":"AAEA;EACC,qCAAA;EACA,gBAAA;EACG,iBAAA;EACA,aAAA;EACH,sBAAA;EACG,aAAA;EACA,sBAAA;EACA,mBAAA;AADJ;AAGI;EACI,YAAA;AADR;AAIC;EACC,YAAA;AAFF;AAGE;EAFD;IAGW,YAAA;EAAV;AACF;AAGI;EACI,oCAAA;EACN,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,YAAA;AADF;AAGQ;EARJ;IASQ,YAAA;EAAV;AACF;;AAIA;EACC,aAAA;EACA,SAAA;EACA,qCAAA;EACA,mBAAA;AADD;AAGC;EAND;IAOE,2BAAA;EAAA;AACF;;AAGA;EACC,aAAA;EACA,mBAAA;EACG,uBAAA;EACH,gBAAA;AAAD;AAEC;EACC,kBAAA;AAAF;AAGC;EACC,YAAA;AADF","sourcesContent":["@import '../variables/breakpoints';\n\n.main {\n\tbackground-color: var(--color-dark-2);\n\tmax-width: 100vw;\n    min-height: 100vh;\n    padding: 5rem;\n\tbox-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    &__img{\n        height: 7rem;\n    }\n\n\t&__titles {\n\t\twidth: 60rem;\n\t\t@media only screen and (max-width: $bp-500) {\n            width: 42rem;\n        }\n\t}\n\n    &__form {\n        background-color: var(--color-white);\n\t\tpadding: 4rem 2rem;\n\t\tmargin: 1rem 3rem;\n\t\tborder-radius: 2rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\twidth: 50rem;\n\n        @media only screen and (max-width: $bp-500) {\n            width: 38rem;\n        }\n    }\n}\n\n.beside {\n\tdisplay: grid;\n\tgap: 2rem;\n\tgrid-template-columns: repeat(2, 1fr);\n\tmargin-bottom: 2rem;\n\n\t@media only screen and (max-width: $bp-400) {\n\t\tgrid-template-columns: 100%;\n\t}\n}\n\n.mima {\n\tdisplay: flex;\n\talign-items: center;\n    justify-content: center;\n\tmargin-top: 3rem;\n\n\t& > :not(:last-child) {\n\t\tmargin-right: 1rem;\n\t}\n\n\t&__logo {\n\t\theight: 3rem;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `BookingLink_main__9cR36`,
	"main__img": `BookingLink_main__img__07hmy`,
	"main__titles": `BookingLink_main__titles__WQRGs`,
	"main__form": `BookingLink_main__form__qtAqc`,
	"beside": `BookingLink_beside__+43MD`,
	"mima": `BookingLink_mima__qIsQq`,
	"mima__logo": `BookingLink_mima__logo__Kd3x9`
};
export default ___CSS_LOADER_EXPORT___;
